import React from 'react'
import { DatePanel, DateItem, Column } from './index.styled'
import { useNotesHistory } from './useNotesHistory'

export default function NotesHistoryPanel() {
  const { flatHistory, handleNoteClick, historySelectedNoteId } = useNotesHistory()

  return (
    <Column>
      <DatePanel>
        {flatHistory.map((item) => (
          <DateItem
            key={item.id}
            onClick={() => handleNoteClick(item.id)}
            $isSelected={historySelectedNoteId === item.id}
            style={{
              fontWeight: item.isToday ? 'bold' : 'normal',
            }}
          >
            {item.displayDate}
          </DateItem>
        ))}
      </DatePanel>
    </Column>
  )
}
